'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _publishers = require('../publishers/publishers');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl, publisher) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
    this.publisher = publisher;

    if (!this.publisher) {
      this.publisher = (0, _publishers.getPublisherByType)();
    }
  }

  Reporter.prototype.getBaseUrl = function getBaseUrl() {
    return this.baseUrl;
  };

  Reporter.prototype.getPublisher = function getPublisher() {
    return this.publisher;
  };

  Reporter.prototype.report = function report(data) {
    if (!data) {
      return null;
    }

    return this.publisher(this.baseUrl, data);
  };

  return Reporter;
}();

exports.default = Reporter;